<template>
  <div class="stepper-heading-container">
    <div class="heading-wrapper">
      <div class="heading-main">
        <div class="step-badge">Step {{ step }}</div>
        <h2 class="step-title">{{ title }}</h2>
      </div>
      
      <button
        class="help-toggle"
        type="button"
        data-bs-toggle="collapse"
        :data-bs-target="'#helpCollapse-' + step"
        aria-expanded="true"
        :aria-controls="'helpCollapse-' + step"
        :class="{ 'collapsed': !isHelpExpanded }"
        @click="toggleHelp"
      >
        <span v-if="isHelpExpanded">Hide Help</span>
        <span v-else>Show Help</span>
        <i class="bi" :class="isHelpExpanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </button>
    </div>

    <!-- Collapsible Help Section -->
    <div class="collapse show help-panel" :id="'helpCollapse-' + step">
      <div class="help-content">
        <slot name="help">No additional information available.</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepperHeading',
  props: {
    title: {
      type: String,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isHelpExpanded: true
    };
  },
  methods: {
    toggleHelp() {
      this.isHelpExpanded = !this.isHelpExpanded;
    }
  }
};
</script>

<style scoped>
.stepper-heading-container {
  margin-bottom: 2rem;
}

.heading-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.heading-main {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.step-badge {
  background-color: #87B140;
  color: white;
  padding: 0.375rem 0.875rem;
  border-radius: 30px;
  font-weight: 600;
  font-size: 0.875rem;
  box-shadow: 0 2px 5px rgba(135, 177, 64, 0.2);
  letter-spacing: 0.02em;
}

.step-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #333;
  margin: 0;
  line-height: 1.2;
}

.help-toggle {
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  color: #555;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.04);
}

.help-toggle:hover {
  background-color: #f0f0f0;
  color: #333;
}

.help-toggle:active {
  transform: translateY(1px);
}

.help-toggle i {
  margin-left: 0.5rem;
  font-size: 0.875rem;
  transition: transform 0.2s ease;
}

.help-toggle.collapsed:hover i {
  transform: translateY(2px);
}

.help-toggle:not(.collapsed):hover i {
  transform: translateY(-2px);
}

.help-panel {
  transition: all 0.3s ease;
}

.help-content {
  background-color: #f9faf5;
  border-left: 3px solid #87B140;
  padding: 1.25rem 1.5rem;
  border-radius: 8px;
  color: #555;
  line-height: 1.6;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.04);
}

.help-content p {
  margin-bottom: 0.875rem;
}

.help-content p:last-child {
  margin-bottom: 0;
}

.help-content ul {
  padding-left: 1.25rem;
  margin-bottom: 0.875rem;
}

.help-content li {
  margin-bottom: 0.5rem;
}

.help-content strong {
  color: #333;
  font-weight: 600;
}

@media (max-width: 768px) {
  .heading-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .heading-main {
    width: 100%;
  }
  
  .help-toggle {
    align-self: flex-end;
  }
  
  .step-title {
    font-size: 1.5rem;
  }
}

@media (max-width: 576px) {
  .stepper-heading-container {
    margin-bottom: 1.5rem;
  }
  
  .heading-main {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .step-badge {
    font-size: 0.75rem;
    padding: 0.25rem 0.75rem;
  }
  
  .step-title {
    font-size: 1.35rem;
  }
  
  .help-content {
    padding: 1rem 1.25rem;
    font-size: 0.95rem;
  }
}
</style>